import { useState, useEffect } from 'react';
import { getFeaturedCourses } from '../services/api/courses';
import { getFeaturedSchools } from '../services/api/schools';

function useGetFeatured(Client) {
  const selected = {
    id: 0,
    name: '',
    category_display: '',
    description: '',
    image: '',
    school_link: '',
    school_name: '',
    course_detail_link: '',
    video: '',
  };
  const initialState = { selected, data: [] };
  const [state, setState] = useState(initialState);

  useEffect(() => {
    // effect
    Client().then(data => {
      setState(oldState => ({
        ...oldState,
        data: data.data,
        selected: data.data[0],
      }));
    });

    return () => {
      // cleanup
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleSelect(key, value) {
    return function() {
      console.log({ key, value });
      const [newSelected] = state.data.filter(item => item[key] === value);
      setState(oldState => ({ ...oldState, selected: newSelected }));
    };
  }

  return {
    handleSelect,
    selected: state.selected,
    data: state.data,
  };
}

export function useGetFeaturedCourses() {
  return useGetFeatured(getFeaturedCourses);
}

export function useGetFeaturedSchools() {
  return useGetFeatured(getFeaturedSchools);
}
